// extracted by mini-css-extract-plugin
export default {"container":"pageLoader_container__34Hbv"};